import { Chip, styled, Theme } from "@mui/material";
import { CHAT_ELEMENT_HEIGHT } from "../components/consts/sizeConsts";
import { PatientColorMap } from "../layout/patientColorMap";

export const AnswerChip = styled(Chip)(
  ({
    theme,
    "data-selected": selected,
  }: {
    theme?: Theme;
    "data-selected"?: boolean;
  }) => ({
    maxWidth: "fit-content",
    flex: 2,
    fontWeight: 500,
    fontSize: "15px",
    marginRight: "10px",
    height: "auto",
    minHeight: CHAT_ELEMENT_HEIGHT, // Allow text to wrap
    borderRadius: "60px",
    padding: "10px",
    cursor: "pointer",
    color: selected ? "white" : PatientColorMap.Default,
    backgroundColor: selected
      ? PatientColorMap.Selected
      : PatientColorMap.Unselected,
    "&:focus, &:hover, &:active": {
      color: selected ? "white" : PatientColorMap.Default,
      backgroundColor: selected
        ? PatientColorMap.Selected
        : PatientColorMap.Unselected,
    },
    "& .patient-MuiTypography-root": {
      color: selected ? "white" : PatientColorMap.Default,
      fontWeight: 500,
    },
    "& .patient-MuiChip-label": {
      whiteSpace: "break-spaces",
    },
  }),
);
